<template>
    <standard-attachment-preview
        :image-source="imageSource"
        :name="name"
        :user-name="model.userName"
        :upload-date="model.uploadDate"
        :content-type="contentType"
        :can-upload="canUpload"
        :can-remove="canRemove"
        @upload="onUpload"
        @remove="onRemove"
    />
</template>
<script>
import dayjs from 'dayjs';

export default {
    props: ['model', 'name', 'canUpload', 'canRemove'],
    data() {
        return { show: false, hover: false, reloading: false };
    },
    methods: {
        onUpload($event) {
            this.$emit('onUpload', $event, this.model.locationFileType);
        },
        onRemove() {
            this.$emit('onRemove', this.model.locationFileId);
            this.show = false;
        }
    },
    computed: {
        isEmpty() {
            return !this.imageSource;
        },
        previewSource() {
            if (this.isEmpty) return 'data:,';
            if (!this.isDocumentType) return this.imageSource;
            return '/img/doc-placeholder.png';
        },
        imageSource() {
            return this.model.imageSource;
        },
        isPdf() {
            return (this.contentType || '').includes('/pdf');
        },
        contentType() {
            return this.model.imageContentType;
        },
        locationFileType() {
            return this.model.locationFileType;
        },
        isDocumentType() {
            return this.isPdf;
        },
        uploadText() {
            let uploadDate = dayjs(this.model.uploadDate).format('YYYY-MM-DD HH:mm');
            return `${this.name} uploaded by ${this.model.userName} on ${uploadDate}`;
        }
    }
};
</script>
<style lang="scss">
.v-dialog.lightbox {
    width: auto;
}
object.preview {
    height: 80vh;
    width: 80vw;
}
</style>
